import React, { useState, useEffect, useRef, useCallback } from "react";
import ClinicianInfo from "./clinicianInfo";
import QuickAddAppointmentModal from "../../../modals/QuickAddAppointmentModal";
import CalendarEvent from "./CalendarEvent";
import ContextMenu from "../ContextMenu";
import { useDispatch } from "react-redux";
import {
  fetchAppointmentsByClinicianId,
  saveAppointment,
  updateAppointmentStatus,
} from "../../../store/thunks/appointmentsThunk";
import QuickAddMeeting from "../../../modals/QuickAddMeeting";
import { setSelectedMeeting } from "../../../store/slices/meetingSlice";
import { useSelector } from "react-redux";
import RescheduleModal from "../../../applicationUi/components/RescheduleModal";
import { setSelectedAppointment } from "../../../store/slices/appointmentsSlice";
import CancelAppointmentModal from "../../../applicationUi/components/CancelAppointmentModal";
import NoShowAppointmentModal from "../../../applicationUi/components/NoShowAppointmentModal";
import SOAPForm from "../../../applicationUi/components/SOAPForm";
import InvoiceModal from "../../../applicationUi/components/InvoiceModal";
import CancelMeetingModal from "../../../applicationUi/components/CancelMeetingModal";
import { deleteMeetingThunk, updateMeetingThunk } from "../../../store/store";
import QuickAddIntake from "../../../modals/QuickAddIntake";

const ClinicianSchedule = ({
  clinician,
  appointments,
  currentDate,
  handleAppointmentClick, // Receive the handleAppointmentClick function as a prop
  clinic,
  showWorkingHours, // New prop for working hours toggle
  onReschedule, // Add this prop to handle reschedule
  rescheduleData,
  dailyNote,
  handleNoteUpdate,
  handleNoteDelete,
  handleMeetingUpdate,
  meetings,
  onAppointmentHover, // Add hover handler prop
  onAppointmentHoverEnd, // Add hover end handler prop
  showAllClinics, // New prop to show all clinics mode
  clinicianClinic, // Clinician's clinic info
  allClinics, // All clinics for color mapping
}) => {
  const dispatch = useDispatch();
  const contextMenuRef = useRef(null);

  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [appointmentDetails, setAppointmentDetails] = useState(null);
  const [selectedClinicianInfo, setSelectedClinicianInfo] = useState(clinician);
  const [currentStep, setCurrentStep] = useState("add"); // 'add' or 'confirm'
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [filteredMeetings, setFilteredMeetings] = useState([]);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    appointment: null,
  });
  const [showSOAPForm, setShowSOAPForm] = useState(false);
  const [soapFormAppointment, setSoapFormAppointment] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [currentTimePosition, setCurrentTimePosition] = useState(null);
  const startHour = showWorkingHours ? 8 : 0;
  const endHour = showWorkingHours ? 20 : 24;
  const hoursToShow = endHour - startHour;
  const statusOptions = [
    "Booked",
    "Changed",
    "Cancelled",
    "Cancelled - No Fee",
    "Cancelled - Charge Fee",
    "No Show",
    "No Show - No Fee",
    "No Show - Charge Fee",
    "Tentative",
    "Confirmed",
    "Treated",
    "Completed",
    "Invoiced",
    "Invoice Paid",
    "Soap Notes Complete",
    "Comments",
    "Paid to Clinician",
  ];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showStatusSelector, setShowStatusSelector] = useState(false);

  const [passedRescheduleData, setPassedRescheduleData] = useState({});
  const [maxColumns, setMaxColumns] = useState(1);
  const selectedClinic = useSelector(
    (state) => state.clinics.selectedClinic || null
  );
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showNoShowModal, setShowNoShowModal] = useState(false);
  const [showBookIntakeModal, setShowBookIntakeModal] = useState(false);
  const [selectedAppointmentForAction, setSelectedAppointmentForAction] =
    useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const user = useSelector((state) => state.auth.user || null);

  const [isQuickAddMeetingOpen, setIsQuickAddMeetingOpen] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);

  const [showCancelMeetingModal, setShowCancelMeetingModal] = useState(false);
  const [selectedMeetingForCancel, setSelectedMeetingForCancel] =
    useState(null);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);

  useEffect(() => {
    if (rescheduleData && rescheduleData !== passedRescheduleData) {
      setPassedRescheduleData(rescheduleData);
    } else {
    }
  }, [rescheduleData, passedRescheduleData]);

  // Refetch appointments
  const refetchAppointments = (clinicianId) => {
    dispatch(fetchAppointmentsByClinicianId(clinicianId));
  };

  // Handler to filter appointments based on clinician and current date
  const filterAppointments = () => {
    const clinicianAppointments = appointments.filter((appointment) => {
      const appointmentDate = new Date(appointment.start);

      // Filter by clinician and date
      const matchesClinicianAndDate =
        appointment.clinician?._id === clinician._id &&
        appointmentDate.toDateString() === currentDate.toDateString();

      // Filter out cancelled and no-show appointments
      const isNotCancelled = !appointment.status?.some((status) =>
        [
          "Cancelled",
          "Cancelled - No Fee",
          "Cancelled - Charge Fee",
          "Cancelled - Clinician",
          "Cancelled - Client",
          "No Show",
          "No Show - No Fee",
          "No Show - Charge Fee",
        ].includes(status)
      );

      return matchesClinicianAndDate && isNotCancelled;
    });
    setFilteredAppointments(clinicianAppointments);
  };

  // Call filterAppointments on component mount and when dependencies change
  useEffect(() => {
    filterAppointments();
  }, [appointments, clinician, currentDate]);

  // // Get appointments matching the current date
  // useEffect(() => {
  //   const clinicianAppointments = appointments.filter((appointment) => {
  //     const appointmentDate = new Date(appointment.start);
  //     return (
  //       appointment.clinician?._id === clinician._id &&
  //       appointmentDate.toDateString() === currentDate.toDateString()
  //     );
  //   });
  //   setFilteredAppointments(clinicianAppointments);
  // }, [appointments, clinician, currentDate]);

  // Get meetings matching the current date
  useEffect(() => {
    const clinicianMeetings = meetings.filter((meeting) => {
      const meetingDate = new Date(meeting.date).toDateString();
      const todayDate = currentDate.toDateString();
      const isClinicianAttending = meeting.attendees.some(
        (attendee) => attendee._id === clinician._id
      );
      return meetingDate === todayDate && isClinicianAttending;
    });
    setFilteredMeetings(clinicianMeetings);
  }, [meetings, clinician, currentDate]);

  // Move this logic outside of renderAppointments
  useEffect(() => {
    const appointmentsWithColumns =
      calculateAppointmentsWithColumns(filteredAppointments);
    const max = Math.max(
      ...appointmentsWithColumns.map((a) => a.maxColumns),
      1
    );
    setMaxColumns(max);
  }, [filteredAppointments]);

  const renderAppointmentsAndMeetings = () => {
    const allEvents = [
      ...filteredAppointments,
      ...filteredMeetings.map((meeting) => ({
        ...meeting,
        start: new Date(`${meeting.date.split("T")[0]}T${meeting.startTime}`),
        end: new Date(
          new Date(
            `${meeting.date.split("T")[0]}T${meeting.startTime}`
          ).getTime() +
            meeting.duration * 60000
        ),
        isMeeting: true,
      })),
    ];

    const eventsWithColumns = calculateAppointmentsWithColumns(allEvents);

    return eventsWithColumns.map((event) => (
      // console.log("THIS IS THE EVENT WITH COLUMNS", event),
      <CalendarEvent
        key={event._id}
        appointment={event}
        onClick={() => {
          if (event.isMeeting) {
            handleMeetingClick(event);
          } else {
            handleAppointmentClick(event);
          }
        }}
        onRightClick={(e) => handleRightClick(e, event)}
        column={event.column}
        maxColumns={maxColumns}
        startHour={startHour}
        onAppointmentHover={onAppointmentHover}
        onAppointmentHoverEnd={onAppointmentHoverEnd}
      />
    ));
  };

  // Helper function to calculate appointments with columns
  const calculateAppointmentsWithColumns = (appointments) => {
    const appointmentsWithColumns = [];
    const overlappingAppointments = [];

    appointments.forEach((appointment) => {
      const start = new Date(appointment.start).getTime();
      const end = new Date(appointment.end).getTime();
      let placed = false;

      for (let i = 0; i < overlappingAppointments.length; i++) {
        const overlap = overlappingAppointments[i];
        if (
          overlap.every(
            (a) =>
              start >= new Date(a.end).getTime() ||
              end <= new Date(a.start).getTime()
          )
        ) {
          overlap.push(appointment);
          appointmentsWithColumns.push({
            ...appointment,
            column: i,
            maxColumns: overlappingAppointments.length,
          });
          placed = true;
          break;
        }
      }

      if (!placed) {
        overlappingAppointments.push([appointment]);
        appointmentsWithColumns.push({
          ...appointment,
          column: overlappingAppointments.length - 1,
          maxColumns: overlappingAppointments.length,
        });
      }
    });

    return appointmentsWithColumns;
  };

  // For the red line
  useEffect(() => {
    const updateCurrentTimePosition = () => {
      const now = new Date();
      if (now.toDateString() === currentDate.toDateString()) {
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        if (currentHour >= startHour && currentHour < endHour) {
          const minutesSinceStart =
            (currentHour - startHour) * 60 + currentMinute;
          const position = (minutesSinceStart / (hoursToShow * 60)) * 100;
          setCurrentTimePosition(position);
        } else {
          setCurrentTimePosition(null);
        }
      } else {
        setCurrentTimePosition(null);
      }
    };

    updateCurrentTimePosition();
    const interval = setInterval(updateCurrentTimePosition, 60000);

    return () => clearInterval(interval);
  }, [currentDate, startHour, endHour, hoursToShow]);

  const handleCreateSOAPNote = (appointment) => {
    setShowSOAPForm(true);
    dispatch(setSelectedAppointment(appointment));
    handleContextMenuClose(); // Close context menu after option is clicked
  };

  const handleReschedule = (appointment) => {
    console.log("Reschedule clicked", appointment);
    dispatch(setSelectedAppointment(appointment));
    setSelectedAppointmentId(appointment._id);
    setShowRescheduleModal(true);
    console.log("Reschedule clicked", appointment);
  };

  const handleMarkConfirmed = (appointment) => {
    dispatch(
      updateAppointmentStatus({
        appointmentId: appointment._id,
        status: "Confirmed",
        comments: `Status changed to Confirmed`,
        userId: user._id,
      })
    );
    refetchAppointments(appointment.clinician._id);
  };

  const handleMarkTentative = (appointment) => {
    dispatch(
      updateAppointmentStatus({
        appointmentId: appointment._id,
        status: "Tentative",
        comments: `Status changed to Tentative`,
        userId: user._id,
      })
    );
    refetchAppointments(appointment.clinician._id);
  };

  const handleMarkTreated = (appointment) => {
    dispatch(
      updateAppointmentStatus({
        appointmentId: appointment._id,
        status: "Treated",
        comments: `Status changed to Treated`,
        userId: user._id,
      })
    );
    refetchAppointments(appointment.clinician._id);
  };

  const handleCreateInvoice = (appointment) => {
    setSelectedAppointmentForAction(appointment);
    setShowInvoiceModal(true);
    handleContextMenuClose();
    console.log("Create invoice clicked", appointment);
  };

  const handleCollectPayment = (appointment) => {
    console.log("Collect payment clicked", appointment);
  };

  const handleCancel = (appointment) => {
    console.log("Cancel clicked", appointment);
    setSelectedAppointmentForAction(appointment);
    setShowCancelModal(true);
    handleContextMenuClose();
  };

  const handleNoShow = (appointment) => {
    console.log("No Show clicked", appointment);
    setSelectedAppointmentForAction(appointment);
    setShowNoShowModal(true);
    handleContextMenuClose();
  };

  const handleRescheduleModalClose = () => {
    setShowRescheduleModal(false);
    refetchAppointments(clinician._id);
  };

  const handleStatusChange = () => {
    if (!contextMenu.appointment) {
      console.error("No appointment selected.");
      return;
    }

    const updatedAppointment = {
      ...contextMenu.appointment,
      status: [selectedStatus],
      history: [
        ...(contextMenu.appointment.history || []),
        {
          status: selectedStatus,
          timestamp: new Date(),
          comments: `Marked as ${selectedStatus}`,
          user: contextMenu.appointment.clinician, // assuming the clinician is the user marking it
        },
      ],
    };

    dispatch(saveAppointment(updatedAppointment))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          console.log(
            `Appointment marked as ${selectedStatus}:`,
            response.payload
          );
          // Refetch appointments
          refetchAppointments(contextMenu.appointment.clinician._id);
        }
      })
      .catch((error) => {
        console.error(
          `Failed to mark appointment as ${selectedStatus}:`,
          error
        );
      });

    setShowStatusSelector(false); // Close status selector
    handleContextMenuClose(); // Close context menu after action
  };

  // Show right click menu
  const handleRightClick = (e, appointment) => {
    e.preventDefault();
    console.log("Appointment:", appointment);

    // Define context menu options based on whether it's a meeting or appointment
    const contextMenuOptions = appointment
      ? appointment.isMeeting
        ? [
            {
              label: "Cancel Meeting",
              onClick: () => handleCancelMeeting(appointment),
            },
            {
              label: "Reschedule Meeting",
              onClick: () => handleRescheduleMeeting(appointment),
            },
            {
              label: "Edit Meeting Details",
              onClick: () => handleEditMeeting(appointment),
            },
          ]
        : [
            ...(["Booked", "Changed", "Tentative", "Confirmed"].some((status) =>
              appointment.status.includes(status)
            )
              ? [
                  {
                    label: "Reschedule",
                    onClick: () => handleReschedule(appointment),
                  },
                ]
              : []),
            ...(["Booked", "Changed", "Tentative", "Confirmed"].some((status) =>
              appointment.status.some((s) => s === status)
            )
              ? [
                  {
                    label: "Cancel Appt",
                    onClick: () => handleCancel(appointment),
                  },
                ]
              : []),
            ...(["Booked", "Changed", "Tentative", "Confirmed"].some((status) =>
              appointment.status.some((s) => s === status)
            )
              ? [
                  {
                    label: "No Show",
                    onClick: () => handleNoShow(appointment),
                  },
                ]
              : []),
            ...(["Booked", "Changed", "Tentative"].some((status) =>
              appointment.status.some((s) => s === status)
            )
              ? [
                  {
                    label: "Mark Tentative",
                    onClick: () => handleMarkTentative(appointment),
                  },
                ]
              : []),
            ...(["Booked", "Changed", "Tentative"].some((status) =>
              appointment.status.some((s) => s === status)
            )
              ? [
                  {
                    label: "Mark Confirmed",
                    onClick: () => handleMarkConfirmed(appointment),
                  },
                ]
              : []),
            ...(appointment.history.some((h) => h.status.includes("Treated"))
              ? [
                  {
                    label: "SOAP Note",
                    onClick: handleCreateSOAPNote,
                  },
                ]
              : []),
            ...(appointment.status.some((s) => s === "Confirmed")
              ? [
                  {
                    label: "Mark Treated",
                    onClick: () => handleMarkTreated(appointment),
                  },
                ]
              : []),
            ...(appointment.status.some((s) => s === "Treated")
              ? [
                  {
                    label: "Invoice",
                    onClick: () => handleCreateInvoice(appointment),
                  },
                ]
              : []),
            ...(appointment.status.some((s) => s === "Invoiced")
              ? [
                  {
                    label: "Collect Payment",
                    onClick: () => handleCollectPayment(appointment),
                  },
                ]
              : []),
          ]
      : [];

    // Calculate available space
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const menuWidth = 200; // Set exact menu width
    const menuHeight = contextMenuOptions.length * 50; // Set a fixed height per option

    // Adjust x position if menu would go off right edge
    let x = e.clientX;
    if (x + menuWidth > viewportWidth) {
      x = viewportWidth - menuWidth;
    }

    // Adjust y position if menu would go off bottom edge
    let y = e.clientY;
    if (y + menuHeight > viewportHeight) {
      y = viewportHeight - menuHeight;
    }

    // Set the context menu visibility and adjusted position
    setContextMenu({
      visible: true,
      x,
      y,
      appointment,
      options: contextMenuOptions,
    });
    setShowStatusSelector(false);
  };

  // Create appointment or show context menu
  const handleGridRightClick = (e) => {
    e.preventDefault();
    const clickedGridItem = e.target.closest("li");
    if (clickedGridItem) {
      const row = parseInt(clickedGridItem.dataset.row, 10);
      if (row >= 2 && row <= hoursToShow * 12) {
        const hour = startHour + Math.floor((row - 2) / 12);
        const minute = ((row - 2) % 12) * 5;
        const timeSelected = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;

        const contextMenuOptions = [
          {
            label: "Create Appointment",
            onClick: () => {
              const modalContent = {
                date: new Date(currentDate),
                time: timeSelected,
                clinicianFname: clinician.firstName,
                clinicianLname: clinician.lastName,
              };
              console.log("Appointment Modal Content:", modalContent);
              setModalContent(modalContent);
              setSelectedClinicianInfo(clinician);
              setShowAppointmentModal(true);
            },
          },
          {
            label: "Create Meeting",
            onClick: () => {
              const modalContent = {
                date: new Date(currentDate),
                time: timeSelected,
                clinicianFname: clinician.firstName,
                clinicianLname: clinician.lastName,
              };
              console.log("Meeting Modal Content:", modalContent);
              setModalContent(modalContent);
              setSelectedClinicianInfo(clinician);
              setShowMeetingModal(true);
              console.log("Meeting clicked");
            },
          },
          {
            label: "Create New Intake",
            onClick: () => {
              const modalContent = {
                date: new Date(currentDate),
                time: timeSelected,
                clinicianFname: clinician.firstName,
                clinicianLname: clinician.lastName,
                isIntake: true
              };
              console.log("Intake Modal Content:", modalContent);
              setModalContent(modalContent);
              setSelectedClinicianInfo(clinician);
              setShowBookIntakeModal(true);
            },
          },
        ];

        setContextMenu({
          visible: true,
          x: e.clientX,
          y: e.clientY,
          appointment: null,
          options: contextMenuOptions,
        });
      }
    }
  };

  const handleContextMenuClose = () => {
    setContextMenu({ visible: false, x: 0, y: 0, appointment: null });
    setShowStatusSelector(false); // Ensure the selector is hidden when the context menu is closed
  };

  const handleAppointmentModalClose = () => {
    console.log("Handle Modal Close - Clinician Schedule");
    setShowAppointmentModal(false);
    setShowDetailsModal(false);
    setShowSOAPForm(false); // Close SOAP form as well
    filterAppointments();
    // refetchAppointments();
    // console.log('logging contextmenu',contextMenu);
    // refetchAppointments(contextMenu.clinician._id);
  };

  const handleMeetingModalClose = (onClose) => {
    console.log("Handle Modal Close - Clinician Schedule");
    setShowMeetingModal(false);
    setShowDetailsModal(false);
    setShowSOAPForm(false);
    dispatch(setSelectedMeeting(null));

    if (handleMeetingUpdate) {
      handleMeetingUpdate(); // Call the callback in the parent
    }

    if (onClose && typeof onClose === "function") {
      onClose(); // Call the onClose function if provided
    }
  };

  const handleMeetingClick = (event) => {
    console.log("Meeting clicked", event);
    // Convert dates to ISO strings before dispatching
    const serializedMeeting = {
      ...event,
      start: event.start.toISOString(),
      end: event.end.toISOString(),
      date: event.date ? new Date(event.date).toISOString() : null,
    };
    dispatch(setSelectedMeeting(serializedMeeting));
    setModalContent({
      ...event,
      isMeeting: true, // Ensure isMeeting flag is set
    });
    setShowMeetingModal(true);
  };

  const handleSoapModalClose = () => {
    console.log("Handle Modal Close - Clinician Schedule");
    setShowSOAPForm(false); // Close SOAP form as well
  };

  const handleAppointmentSave = (appointmentData) => {
    setAppointmentDetails(appointmentData);
    setShowAppointmentModal(false);
    setShowDetailsModal(true);
    // setCurrentStep("confirm");
  };

  const handleMeetingSave = (meetingData) => {
    setAppointmentDetails(meetingData);
    setShowMeetingModal(false);
    setShowDetailsModal(true);

    // setCurrentStep("confirm");
  };

  const handleMouseEnter = (rowIndex) => {
    setHoveredRow(rowIndex);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };

  const handleConfirmCancelNoFee = () => {
    console.log("Confirm Cancel No Fee clicked");
    setShowCancelModal(false);
  };

  const handleConfirmCancelWithFee = () => {
    console.log("Confirm Cancel With Fee clicked");
    setShowCancelModal(false);
  };

  const handleClinicianCancel = () => {
    console.log("Confirm Clinician Cancel clicked");
    setShowCancelModal(false);
  };

  const handleConfirmNoShowNoFee = () => {
    console.log("Confirm No Show No Fee clicked");
    setShowNoShowModal(false);
  };

  const handleConfirmNoShowWithFee = () => {
    console.log("Confirm No Show With Fee clicked");
    setShowNoShowModal(false);
  };

  const formatTime = (rowIndex) => {
    const totalMinutes = rowIndex * 5 - 5;
    const hour = startHour + Math.floor(totalMinutes / 60);
    const minute = totalMinutes % 60;

    return new Date(
      `1970-01-01T${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}:00`
    ).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target)
      ) {
        handleContextMenuClose();
      }
    };

    if (contextMenu.visible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [contextMenu.visible]);

  const handleCancelMeeting = (meeting) => {
    setSelectedMeetingForCancel(meeting);
    setShowCancelMeetingModal(true);
    handleContextMenuClose();
  };

  const handleRescheduleMeeting = (meeting) => {
    // Convert dates to ISO strings before dispatching
    const serializedMeeting = {
      ...meeting,
      start: meeting.start.toISOString(),
      end: meeting.end.toISOString(),
      date: meeting.date ? new Date(meeting.date).toISOString() : null,
    };
    dispatch(setSelectedMeeting(serializedMeeting));
    setModalContent({
      ...meeting,
      isMeeting: true, // Ensure isMeeting flag is set
    });
    setShowMeetingModal(true);
    handleContextMenuClose();
  };

  const handleEditMeeting = (meeting) => {
    // Convert dates to ISO strings before dispatching
    const serializedMeeting = {
      ...meeting,
      start: meeting.start.toISOString(),
      end: meeting.end.toISOString(),
      date: meeting.date ? new Date(meeting.date).toISOString() : null,
    };
    dispatch(setSelectedMeeting(serializedMeeting));
    setModalContent({
      ...meeting,
      isMeeting: true, // Ensure isMeeting flag is set
    });
    setShowMeetingModal(true);
    handleContextMenuClose();
  };

  const getMeetingContextMenuOptions = (meeting) => [
    {
      label: "View Details",
      onClick: () => {
        setSelectedMeeting(meeting);
        setIsQuickAddMeetingOpen(true);
        setShowContextMenu(false);
      },
    },
    {
      label: "Edit Meeting",
      onClick: () => {
        handleEditMeeting(meeting);
        setShowContextMenu(false);
      },
    },
    {
      label: "Reschedule Meeting",
      onClick: () => {
        handleRescheduleMeeting(meeting);
        setShowContextMenu(false);
      },
    },
    {
      label: "Cancel Meeting",
      onClick: () => {
        handleCancelMeeting(meeting);
        setShowContextMenu(false);
      },
    },
  ];

  const handleCancelMeetingForAll = () => {
    if (selectedMeetingForCancel) {
      dispatch(deleteMeetingThunk(selectedMeetingForCancel._id))
        .then(() => {
          // Update meetings list after successful deletion
          if (handleMeetingUpdate) {
            handleMeetingUpdate();
          }
        })
        .catch((error) => {
          console.error("Failed to cancel meeting:", error);
        });
    }
    setShowCancelMeetingModal(false);
  };

  const handleCancelMeetingForSelf = () => {
    if (selectedMeetingForCancel) {
      console.log("selectedMeetingForCancel", selectedMeetingForCancel);
      console.log("meeting id", selectedMeetingForCancel._id);
      console.log("clinician to remove", clinician._id);

      // Sanitize the updatedMeeting object to match schema requirements
      const updatedMeeting = {
        title: selectedMeetingForCancel.title,
        clinic: selectedMeetingForCancel.clinic._id, // Ensure clinic is just the ObjectId
        date: selectedMeetingForCancel.date,
        startTime: selectedMeetingForCancel.startTime,
        duration: selectedMeetingForCancel.duration,
        attendees: selectedMeetingForCancel.attendees
          .map((attendee) => attendee._id) // Extract only ObjectIds for attendees
          .filter((attendeeId) => attendeeId !== clinician._id), // Remove clinician's ObjectId
        description: selectedMeetingForCancel.description,
        createdBy: user._id, // Add the user's ObjectId as createdBy
      };

      console.log("Updated Meeting Payload:", updatedMeeting);

      // Update meeting with filtered attendees
      dispatch(
        updateMeetingThunk({
          id: selectedMeetingForCancel._id,
          updatedData: updatedMeeting,
        })
      )
        .then(() => {
          if (handleMeetingUpdate) {
            handleMeetingUpdate();
          }
        })
        .catch((error) => {
          console.error("Failed to update meeting:", error);
        });
    }
    setShowCancelMeetingModal(false);
  };

  return (
    <>
      <div className="sticky top-0 z-40 bg-white border-b shadow-sm">
        <ClinicianInfo
          clinician={clinician}
          calendarDate={currentDate}
          dailyNote={dailyNote}
          onNoteUpdate={handleNoteUpdate}
          onNoteDelete={handleNoteDelete}
          showAllClinics={showAllClinics}
          clinicianClinic={clinicianClinic}
          allClinics={allClinics}
        />
      </div>

      <div className="flex w-full flex-auto">
        <div className="w-14 flex-none bg-white border-r border-gray-200 relative">
          {currentTimePosition !== null && (
            <div
              className="absolute left-0 text-left pl-2 text-xs leading-5 text-red-600 font-medium bg-white rounded-r-sm px-1 shadow-sm"
              style={{ top: `${currentTimePosition}%` }}>
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </div>
          )}
        </div>

        <div className="grid flex-auto grid-cols-1 grid-rows-1 relative">
          {/* Time labels */}
          <div
            className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100"
            style={{
              gridTemplateRows: `repeat(${
                hoursToShow * 2
              }, minmax(4.5rem, 1fr))`,
            }}>
            <div className="row-end-1 h-7"></div>
            {[...Array(hoursToShow).keys()].map((hour) => {
              // Get current day of week
              const dayOfWeek = new Intl.DateTimeFormat("en-US", {
                weekday: "long",
              }).format(currentDate);

              let daySchedule = null;
              let isDateInRange = false;

              // Find availability for current clinic and date
              if (selectedClinic !== null) {
                const clinicAvailability = clinician?.availability?.find(
                  (a) => {
                    // Check if current date falls within availability period
                    const startDate = new Date(a.startDate);
                    startDate.setHours(0, 0, 0, 0);
                    
                    const endDate = new Date(a.endDate);
                    endDate.setHours(23, 59, 59, 999);
                    
                    const currentDateCopy = new Date(currentDate);
                    currentDateCopy.setHours(12, 0, 0, 0);
                    
                    // First check date range and clinic match
                    const isInRange = currentDateCopy >= startDate && currentDateCopy <= endDate;
                    
                    const isMatchingClinic = a.clinic?.toString() === selectedClinic._id?.toString();

                    // Then check if there are time slots defined for this day
                    const daySchedule = a.schedule?.[dayOfWeek];
                    
                    const hasDaySchedule = daySchedule && daySchedule.length > 0 && 
                                        daySchedule.some(slot => slot.start && slot.end);

                    if (isInRange && isMatchingClinic && hasDaySchedule) {
                      isDateInRange = true;
                      return true;
                    }
                    return false;
                  }
                );
                // Get the day of week in proper case to match schema
                const formattedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);
                daySchedule = clinicAvailability?.schedule?.[formattedDayOfWeek];
              }

              // Check if current hour is within available hours
              const currentHourTime = `${(hour + startHour)
                .toString()
                .padStart(2, "0")}:00`;
              const isAvailable = isDateInRange && daySchedule?.some((slot) => {
                return (
                  currentHourTime >= slot.start && currentHourTime < slot.end
                );
              });

              return (
                <React.Fragment key={hour}>
                  <div className={`${!isAvailable ? "bg-gray-300 border-l-4 border-gray-400" : ""}`}>
                    <div className="sticky z-10 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-500 font-medium bg-white">
                      {(hour + startHour) % 12 === 0
                        ? hour + startHour === 0
                          ? "12AM"
                          : "12PM"
                        : `${(hour + startHour) % 12}${
                            hour + startHour < 12 ? "AM" : "PM"
                          }`}
                    </div>
                  </div>
                  <div className={`${!isAvailable ? "bg-gray-300 border-l-4 border-gray-400" : ""}`} />
                </React.Fragment>
              );
            })}
          </div>

          {/* Time hover indicator grid */}
          <ol
            className="col-start-1 col-end-2 row-start-1 grid relative"
            style={{
              gridTemplateRows: `1.75rem repeat(${
                hoursToShow * 12
              }, minmax(0, 1fr)) auto`,
              gridTemplateColumns: `1fr`,
            }}>
            {Array.from({ length: hoursToShow * 12 }, (_, rowIndex) => (
              <li
                key={rowIndex}
                data-row={rowIndex + 1}
                onMouseEnter={() => handleMouseEnter(rowIndex)}
                onMouseLeave={handleMouseLeave}
                onContextMenu={(e) => handleGridRightClick(e)}
                className={`relative ${
                  hoveredRow === rowIndex ? "bg-gray-100/50" : ""
                }`}
                style={{
                  gridColumn: "1 / -1",
                  zIndex: 10,
                  pointerEvents: "auto",
                }}>
                {hoveredRow === rowIndex && (
                  <div className="absolute -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-500 font-medium bg-white">
                    {formatTime(rowIndex)}
                  </div>
                )}
              </li>
            ))}
          </ol>

          {/* Appointment grid */}
          <div
            className="col-start-1 col-end-2 row-start-1 grid relative"
            onContextMenu={handleGridRightClick}>
            <ol
              className="grid absolute inset-0"
              style={{
                gridTemplateRows: `1.75rem repeat(${
                  hoursToShow * 12
                }, minmax(0, 1fr)) auto`,
                gridTemplateColumns: `repeat(0, 1fr)`,
              }}>
              {renderAppointmentsAndMeetings()}
            </ol>
          </div>

          {currentTimePosition !== null && (
            <div
              className="absolute w-full border-t-2 border-red-500 shadow-sm"
              style={{ top: `${currentTimePosition}%` }}
            />
          )}
        </div>
      </div>

      {contextMenu.visible && (
        <ContextMenu
          ref={contextMenuRef}
          x={contextMenu.x}
          y={contextMenu.y}
          options={contextMenu.options}
          onClose={handleContextMenuClose}
          showStatusSelector={showStatusSelector}
          statusOptions={statusOptions}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          handleStatusChange={handleStatusChange}
        />
      )}

      {showStatusSelector && (
        <div
          className="absolute z-50 bg-white rounded-sm border shadow-lg p-3 min-w-[200px]"
          style={{ top: contextMenu.y, left: contextMenu.x }}>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="w-full rounded-sm border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
            <option value="" disabled>
              Select status
            </option>
            {statusOptions.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
          <div className="flex justify-end gap-2 mt-3">
            <button
              onClick={handleStatusChange}
              className="rounded-sm bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Confirm
            </button>
            <button
              onClick={() => setShowStatusSelector(false)}
              className="rounded-sm bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              Cancel
            </button>
          </div>
        </div>
      )}

      {showAppointmentModal && (
        <QuickAddAppointmentModal
          isOpen={showAppointmentModal}
          onClose={handleAppointmentModalClose}
          initialDate={modalContent?.date}
          initialTime={modalContent?.time}
          initialClinicianFname={modalContent?.clinicianFname}
          initialClinicianLname={modalContent?.clinicianLname}
          rescheduleData={passedRescheduleData}
          onSave={handleAppointmentSave}
          selectedClinician={selectedClinicianInfo}
          clinic={clinic}
        />
      )}
      {showMeetingModal && (
        <QuickAddMeeting
          isOpen={showMeetingModal}
          onClose={handleMeetingModalClose}
          // For new meetings
          initialDate={modalContent?.date}
          initialTime={modalContent?.time}
          initialClinicianFname={modalContent?.clinicianFname}
          initialClinicianLname={modalContent?.clinicianLname}
          selectedClinician={selectedClinicianInfo}
          selectedClinic={clinic}
          // For existing meetings
          selectedMeeting={modalContent?.isMeeting ? modalContent : null}
        />
      )}

      {showBookIntakeModal && (
        <QuickAddIntake
          isOpen={showBookIntakeModal}
          onClose={() => setShowBookIntakeModal(false)}
          initialDate={modalContent?.date}
          initialTime={modalContent?.time}
          initialClinicianFname={modalContent?.clinicianFname}
          initialClinicianLname={modalContent?.clinicianLname}
          rescheduleData={passedRescheduleData}
          onSave={handleAppointmentSave}
          selectedClinician={selectedClinicianInfo}
          selectedClinic={clinic}
        />
      )}

      {showSOAPForm && (
        <SOAPForm
          onClose={handleSoapModalClose}
          appointment={soapFormAppointment}
        />
      )}
      {onReschedule && <QuickAddAppointmentModal appointment={onReschedule} />}
      {showRescheduleModal && (
        <RescheduleModal
          isOpen={showRescheduleModal}
          onClose={handleRescheduleModalClose}
          appointmentId={selectedAppointmentId}
        />
      )}
      {showCancelModal && (
        <CancelAppointmentModal
          isOpen={showCancelModal}
          onClose={() => setShowCancelModal(false)}
          onCancelNoFee={handleConfirmCancelNoFee}
          onCancelWithFee={handleConfirmCancelWithFee}
          onClinicianCancel={handleClinicianCancel}
        />
      )}
      {showNoShowModal && (
        <NoShowAppointmentModal
          isOpen={showNoShowModal}
          onClose={() => setShowNoShowModal(false)}
          onNoShowNoFee={handleConfirmNoShowNoFee}
          onNoShowWithFee={handleConfirmNoShowWithFee}
        />
      )}
      {showInvoiceModal && (
        <InvoiceModal
          isOpen={showInvoiceModal}
          onClose={() => setShowInvoiceModal(false)}
          closeModal={() => setShowInvoiceModal(false)}
        />
      )}
      {showCancelMeetingModal && (
        <CancelMeetingModal
          isOpen={showCancelMeetingModal}
          onClose={() => setShowCancelMeetingModal(false)}
          onCancelForAll={handleCancelMeetingForAll}
          onCancelForSelf={handleCancelMeetingForSelf}
        />
      )}
    </>
  );
};

export default ClinicianSchedule;
